import { useMemo } from 'react';
import { Path, RadioCardOption } from '@ninja/utilities';
import { IEidMembersForm } from '../../../with-eid-members';
import { IMembersForm } from '../../../without-eid-members/members-form/types';
import { usePolicyTypeField } from '../fields';

export const usePolicyTypeFieldsStructure = <TFormValues extends IEidMembersForm | IMembersForm>({
	policyTypeOptions,
}: {
	policyTypeOptions: RadioCardOption<number>[];
}) => {
	const policyTypeField = usePolicyTypeField<TFormValues>();
	const fieldsStructure = useMemo(
		() => [
			policyTypeField.getField({
				field: 'policyTypeId' as Path<TFormValues>,
				cards: policyTypeOptions,
			}),
		],
		[policyTypeOptions, policyTypeField.getField]
	);

	return fieldsStructure;
};
